module.exports = __webpack_public_path__ + "img/euro_green_skoda.a303ac96.svg";